import { LoaderFunction, useFetcher } from "react-router-dom";
import { DecimalResult } from "../../../../common/api/decimal/utils.ts";
import {
  CompareCart,
  addToCart,
  removeFromCart,
} from "common/api/decimal/methods/compareAndPurchase.ts";

export const updateCartAction: LoaderFunction = async ({
  request,
}): Promise<DecimalResult<CompareCart>> => {
  const formData = await request.formData();
  const id = formData.get("id") as string;
  if (request.method === "DELETE") {
    return removeFromCart({ id });
  } else {
    return addToCart({ tempId: id });
  }
};

export function useUpdateCartFetcher() {
  return useFetcher<DecimalResult<CompareCart>>();
}
